import "./footer.css";

const Footer = () => {
    return (
        <div className="footer"> Designed with love by
            <a href="https://linktr.ee/chuksonu"> Kamso Onu</a>
        </div>
    )
}

export default Footer;
